export const BrowserDetectionCookieName = "browser-detection-message";
export const LocationDetectionCookieName = "location-detection-message";
export const FirstPromoterTrackingIDCookieName = "_fprom_tid";
